import { Box, styled } from "@mui/material";
import { colors } from '../../../../theme/colors';

export const MainWrapper = styled(Box)({
  "& table": {
    minWidth: "1900px",
  },
  "& .custom-table-container": {
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.04)",
    border: "1px solid #e2e8f0",
    overflowX: "auto",
    overflowY: "hidden",
    maxWidth: "100%",
    backgroundColor: "#ffffff",
    "&::-webkit-scrollbar": {
      height: "8px",
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f5f9",
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#cbd5e1",
      borderRadius: "4px",
      "&:hover": {
        background: colors.primary,
      },
    },
  },
  "& .MuiTableCell-head": {
    color: "#fff !important",
    fontSize: "13.5px",
    fontWeight: 600,
    backgroundColor: colors.primary,
    backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    padding: "14px 16px",
  },
  "& .table_user-primary-detail": {
    display: "flex",
    gap: 10,
    alignItems: "center",
    "& > div > p": {
      fontSize: "0.875rem",
      "&:nth-of-type(2)": {
        color: "#919EAB",
      },
    },
  },
  "& .MuiAvatar-root": {
    width: 35,
    height: 35,
  },
  "& .MuiFormLabel-root": {
    color: "#475569 !important",
    fontWeight: 500,
    fontSize: "0.875rem",
    "&.Mui-focused": {
      color: `${colors.primary} !important`,
      fontWeight: 600,
    },
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px !important",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease-in-out",
    "& fieldset": {
      borderColor: "#cbd5e1",
      transition: "border-color 0.2s ease-in-out",
    },
    "&:hover fieldset": {
      borderColor: colors.primaryLightBorder,
    },
    "&.Mui-focused": {
      "& fieldset": {
        borderColor: `${colors.primary} !important`,
      },
      boxShadow: `0 0 0 3px ${colors.primaryLight}`,
    },
  },
  "& .btn": {
    backgroundColor: colors.primary,
    color: "#fff",
    borderRadius: "10px",
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 4px 12px rgba(127, 29, 29, 0.2)",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      color: "#fff",
      boxShadow: "0 6px 16px rgba(127, 29, 29, 0.3)",
    },
  },
  "& .btn.Mui-disabled": {
    backgroundColor: colors.buttonDisabled.background,
    color: colors.buttonDisabled.color,
    opacity: 1,
    cursor: "not-allowed",
  },
  "& .MuiTableBody-root .MuiTableRow-root": {
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: colors.sidebarHover,
    },
  },
  "& .action-cell .MuiIconButton-root": {
    border: `1px solid ${colors.primaryLightBorder}`,
    borderRadius: "8px",
    transition: "all 0.2s ease",
    "&.Mui-disabled": {
      border: "1px solid #e5e7eb",
      opacity: 0.5,
    },
  },
  "& .react-datepicker__close-icon": {
    right: "8px",
    "&::after": {
      backgroundColor: colors.primary,
      fontSize: "14px",
    },
  },
  "& .custom-datepicker": {
    width: "100%",
    padding: "10.5px 14px",
    paddingRight: "36px",
    fontSize: "0.875rem",
    borderRadius: "10px",
    border: "1px solid #cbd5e1",
    outline: "none",
    fontFamily: "inherit",
    backgroundColor: "#ffffff",
    boxSizing: "border-box",
    height: "40px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      borderColor: colors.primaryLightBorder,
    },
    "&:focus": {
      borderColor: `${colors.primary} !important`,
      boxShadow: `0 0 0 3px ${colors.primaryLight}`,
    },
  },
});

